import React from 'react';
import { Button } from './Button';
import type { LandingActions } from '../types/actions';
export function StickyMobileCTA({
  onFormCta,
  onBookCall
}: LandingActions) {
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95 px-3 py-2.5 backdrop-blur-md md:hidden" data-id="element-195" data-mp="1orggel4prx7m">
      <div className="flex gap-2" data-id="element-196" data-mp="1tqt6rfusnmey">
        <Button size="md" onClick={() => onFormCta('sticky_bar')} className="flex-1" data-id="element-197" data-mp="1tprtr5u7wpul">
          See How NEXT Helps
        </Button>
        <Button size="md" variant="outline" onClick={() => onBookCall('sticky_bar')} className="flex-1" data-id="element-198" data-mp="111vohcql1pm7">
          Book a Call
        </Button>
      </div>
    </div>;
}